export default __webpack_public_path__ + "static/media/gournay9.88ce31ca.jpg";